(function () {
  'use strict';

  var selectors = {
    siteHeader: '#header',
    navItems: '.header-menu-level-1',
    navLinksWithDropdown: '.header-menu-level-1 > a[data-dropdown-rel]',
    allNavLinks: '.primary-navigation .header-menu-level-1 > a',
    megamenu: '.megamenu-dropdown-container'
  };

  var classes = {
    hasDropdown: 'has-nav-dropdown',
    dropdownActive: 'nav-dropdown-active'
  };

  var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  var siteHeader = document.querySelector(selectors.siteHeader);

  if (!siteHeader) return;

  var hasActiveDropdown = false;
  var closeOnClickActive = false;

  // Mark parent <li> items that contain a megamenu; set initial ARIA on their trigger links
  siteHeader.querySelectorAll(selectors.navLinksWithDropdown).forEach(function (link) {
    var parentLi = link.parentNode;
    var megamenu = parentLi.querySelector(selectors.megamenu);
    if (!megamenu) return;

    parentLi.classList.add(classes.hasDropdown);
    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');

    if (!megamenu.id) {
      var handle = link.getAttribute('data-dropdown-rel') || 'main';
      megamenu.id = 'megamenu-' + handle;
    }
    link.setAttribute('aria-controls', megamenu.id);
    megamenu.setAttribute('role', 'region');
    megamenu.setAttribute('aria-label', link.textContent.trim() + ' menu');
    
    // Add skip megamenu button
    var skipButton = document.createElement('a');
    skipButton.href = '#';
    skipButton.className = 'skip-megamenu-link';
    skipButton.textContent = 'Skip ' + link.textContent.trim() + ' menu';
    skipButton.setAttribute('tabindex', '-1');
    
    // Set initial hidden styles directly on element
    skipButton.style.position = 'absolute';
    skipButton.style.left = '-10000px';
    skipButton.style.top = '0';
    skipButton.style.width = '1px';
    skipButton.style.height = '1px';
    skipButton.style.overflow = 'hidden';
    
    // Show on focus
    skipButton.addEventListener('focus', function() {
      skipButton.style.position = 'fixed';
      skipButton.style.top = '10px';
      skipButton.style.left = '10px';
      skipButton.style.width = 'auto';
      skipButton.style.height = 'auto';
      skipButton.style.overflow = 'visible';
      skipButton.style.clip = 'auto';
      skipButton.style.display = 'block';
      skipButton.style.zIndex = '99999';
      skipButton.style.whiteSpace = 'nowrap';
      skipButton.style.padding = '0.75rem 1.5rem';
      skipButton.style.background = '#433220';
      skipButton.style.color = '#fff';
      skipButton.style.textDecoration = 'none';
      skipButton.style.fontWeight = '600';
      skipButton.style.fontSize = '0.875rem';
      skipButton.style.lineHeight = '1.5';
      skipButton.style.border = 'none';
      skipButton.style.borderRadius = '0';
      skipButton.style.boxShadow = 'none';
      skipButton.style.textTransform = 'uppercase';
      skipButton.style.letterSpacing = '0.05em';
      skipButton.style.transition = 'background-color 0.2s ease';
    });
    
    // Hide on blur
    skipButton.addEventListener('blur', function() {
      skipButton.style.position = 'absolute';
      skipButton.style.left = '-10000px';
      skipButton.style.top = '0';
      skipButton.style.width = '1px';
      skipButton.style.height = '1px';
      skipButton.style.overflow = 'hidden';
    });
    
    skipButton.addEventListener('click', function(e) {
      e.preventDefault();
      closeDropdowns();
      // Find next navigation link
      var nextNavItem = parentLi.nextElementSibling;
      while (nextNavItem && !nextNavItem.querySelector('a')) {
        nextNavItem = nextNavItem.nextElementSibling;
      }
      if (nextNavItem) {
        var nextLink = nextNavItem.querySelector('a');
        if (nextLink) nextLink.focus();
      }
    });
    
    skipButton.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        skipButton.click();
      }
    });
    
    // Insert at the beginning of the megamenu
    megamenu.insertBefore(skipButton, megamenu.firstChild);
  });

  function openDropdown(parentLi) {
    if (!parentLi.classList.contains(classes.hasDropdown)) return;
    parentLi.classList.add(classes.dropdownActive);
    var trigger = parentLi.querySelector('a[aria-haspopup]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    
    // Make skip button focusable when megamenu opens
    var skipButton = parentLi.querySelector('.skip-megamenu-link');
    if (skipButton) {
      skipButton.setAttribute('tabindex', '0');
      skipButton.style.cssText = 'position: absolute; left: -10000px; top: 0; width: 1px; height: 1px; overflow: hidden;';
    }
    
    hasActiveDropdown = true;

    if (!isTouch && !closeOnClickActive) {
      closeOnClickActive = true;
      document.documentElement.addEventListener('click', handleOutsideClick);
    }
  }

  function closeDropdowns() {
    siteHeader.querySelectorAll('.' + classes.dropdownActive).forEach(function (li) {
      li.classList.remove(classes.dropdownActive);
      var trigger = li.querySelector('a[aria-haspopup]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      
      // Make skip button unfocusable when megamenu closes
      var skipButton = li.querySelector('.skip-megamenu-link');
      if (skipButton) {
        skipButton.setAttribute('tabindex', '-1');
        skipButton.style.cssText = 'position: absolute; left: -10000px; top: 0; width: 1px; height: 1px; overflow: hidden;';
      }
    });
    hasActiveDropdown = false;
  }

  function handleOutsideClick() {
    closeDropdowns();
    document.documentElement.removeEventListener('click', handleOutsideClick);
    closeOnClickActive = false;
  }

  // --- TOUCH ---
  // First tap opens the dropdown; second tap follows the link
  if (isTouch) {
    siteHeader.querySelectorAll('.' + classes.hasDropdown + ' > a[aria-haspopup]').forEach(function (link) {
      link.addEventListener('touchend', function (evt) {
        var parentLi = evt.currentTarget.parentNode;
        if (!parentLi.classList.contains(classes.dropdownActive)) {
          evt.preventDefault();
          evt.stopPropagation();
          closeDropdowns();
          openDropdown(parentLi);
        } else {
          window.location.replace(evt.currentTarget.getAttribute('href'));
        }
      });
    });

    // Touching anywhere on the body closes the dropdown …
    document.body.addEventListener('touchend', function (evt) {
      if (siteHeader.contains(evt.target)) return;
      closeDropdowns();
    });

    // … except when touching inside the megamenu itself
    siteHeader.querySelectorAll(selectors.megamenu).forEach(function (el) {
      el.addEventListener('touchend', function (evt) {
        evt.stopImmediatePropagation();
      });
    });
  }

  // --- MOUSE (desktop) ---
  // mouseenter / mouseleave on the whole <li> keeps the dropdown open while
  // the cursor moves between the trigger link and the megamenu panel
  if (!isTouch) {
    siteHeader.querySelectorAll('.' + classes.hasDropdown).forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        if (hasActiveDropdown) closeDropdowns();
        openDropdown(li);
      });
      li.addEventListener('mouseleave', function () {
        closeDropdowns();
      });
    });
  }

  // --- KEYBOARD ---
  // focusin on the top-level trigger link opens the dropdown
  siteHeader.querySelectorAll('.' + classes.hasDropdown).forEach(function (li) {
    var trigger = li.querySelector('a[aria-haspopup]');
    if (!trigger) return;
    trigger.addEventListener('focusin', function () {
      if (hasActiveDropdown) closeDropdowns();
      openDropdown(li);
    });
  });

  // Close dropdown when focus leaves the entire <li> block (trigger + megamenu).
  // Listening on the <li> (instead of only on megamenu links) catches Shift+Tab
  // from the trigger itself when focus jumps backward out of the dropdown region.
  siteHeader.querySelectorAll('.' + classes.hasDropdown).forEach(function (li) {
    li.addEventListener('focusout', function () {
      setTimeout(function () {
        var active = document.activeElement;
        if (!active || !li.contains(active)) {
          closeDropdowns();
        }
      }, 50);
    });
  });

  // Also close when keyboard focus moves to a nav link that has no dropdown
  siteHeader.querySelectorAll(selectors.allNavLinks).forEach(function (link) {
    link.addEventListener('focusin', function () {
      var parentLi = link.parentNode;
      if (!parentLi.classList.contains(classes.hasDropdown) && hasActiveDropdown) {
        closeDropdowns();
      }
    });
  });
})();

(function () {
  'use strict';

  var CART_SELECTOR = '#rebuy-cart';
  var ADD_TO_CART_SELECTORS = [
    'button[name="add"]',
    'button.atc-button',
    'button.atc-button-extra',
    '.ajax-add-to-cart',
    '.ajax-add-to-cart-extra'
  ].join(',');
  var TRIGGER_SELECTORS = [
    ADD_TO_CART_SELECTORS,
    '[data-rebuy-cart-trigger]',
    '[data-cart-drawer-trigger]',
    '[aria-controls="rebuy-cart"]',
    'a[href="/cart"]',
    'a[href^="/cart?"]'
  ].join(',');

  var lastCartTrigger = null;
  var cartWasVisible = false;
  var restoreTimer = 0;
  var restoreAttempts = 0;

  function getCart() {
    return document.querySelector(CART_SELECTOR);
  }

  function isCartVisible(cart) {
    if (!cart) return false;
    if (cart.classList.contains('is-visible')) return true;
    if (cart.getAttribute('aria-hidden') === 'false') return true;
    return document.body.classList.contains('rebuy-cart-visible');
  }

  function rememberTrigger(target) {
    if (!target || !target.closest) return;
    var trigger = target.closest(TRIGGER_SELECTORS);
    if (trigger) lastCartTrigger = trigger;
  }

  function isFocusable(el) {
    if (!el || !document.documentElement.contains(el)) return false;
    if (el.disabled || el.getAttribute('aria-disabled') === 'true') return false;

    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    var rect = el.getBoundingClientRect();
    return rect.width > 0 || rect.height > 0;
  }

  function findFocusable(selector) {
    var triggers = document.querySelectorAll(selector);
    for (var i = 0; i < triggers.length; i++) {
      if (isFocusable(triggers[i])) return triggers[i];
    }
    return null;
  }

  function findFallbackTrigger() {
    if (lastCartTrigger && lastCartTrigger.matches && lastCartTrigger.matches(ADD_TO_CART_SELECTORS)) {
      return findFocusable(ADD_TO_CART_SELECTORS);
    }

    return findFocusable(TRIGGER_SELECTORS);
  }

  function restoreFocus() {
    window.clearTimeout(restoreTimer);

    var target = isFocusable(lastCartTrigger) ? lastCartTrigger : findFallbackTrigger();
    if (target) {
      target.focus({ preventScroll: true });
      restoreAttempts = 0;
      return;
    }

    // Product ATC buttons can be briefly disabled after AJAX success.
    if (restoreAttempts < 40) {
      restoreAttempts += 1;
      restoreTimer = window.setTimeout(restoreFocus, 50);
    } else {
      restoreAttempts = 0;
    }
  }

  function handleCartStateChange() {
    var cart = getCart();
    var isVisible = isCartVisible(cart);

    if (isVisible) {
      cartWasVisible = true;
      return;
    }

    if (!cartWasVisible) return;

    cartWasVisible = false;
    window.setTimeout(restoreFocus, 0);
  }

  document.addEventListener('click', function (evt) {
    rememberTrigger(evt.target);
  }, true);

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Enter' && evt.key !== ' ' && evt.key !== 'Spacebar') return;
    rememberTrigger(document.activeElement);
  }, true);

  document.addEventListener('submit', function (evt) {
    if (evt.target && evt.target.matches && evt.target.matches('form[action="/cart/add"]')) {
      rememberTrigger(document.activeElement);
    }
  }, true);

  if (window.MutationObserver) {
    var observer = new MutationObserver(handleCartStateChange);

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden'],
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', handleCartStateChange);
  window.addEventListener('load', handleCartStateChange);
})();

/*
 * Keyboard focus visibility helper.
 *
 * When the user navigates with Tab / Shift+Tab, the browser will not scroll
 * a focused element into view if it is already inside the viewport rectangle
 * — even when sticky/fixed UI (header, add-to-cart bar) is visually covering
 * it. This module listens to focusin and nudges the page just enough so the
 * focused element is fully clear of any sticky obstruction.
 *
 * WCAG 2.4.11 (Focus Not Obscured) reference.
 */
(function () {
  'use strict';

  // Primary selectors are the ones we want to standardise on; fallback
  // selectors match this theme's existing markup so the script works without
  // re-tagging anything. Order matters — first visible match wins per region.
  var CONFIG = {
    headerSelectors: ['.sticky-header', '[data-plus-sticky-header]', '#header'],
    footerSelectors: ['.sticky-atc', '.sticky-atc_wrapper'],
    buffer: 8 // breathing room around the focus ring (px)
  };

  // Track input modality. Pointer-driven focus (mouse/touch) is intentional
  // and the user already sees where they clicked; we only correct keyboard
  // focus moves.
  var lastInputType = 'initial';
  var KEYBOARD_KEYS = {
    Tab: 1, ArrowUp: 1, ArrowDown: 1, ArrowLeft: 1, ArrowRight: 1,
    Home: 1, End: 1, PageUp: 1, PageDown: 1, Enter: 1, ' ': 1, Spacebar: 1
  };

  document.addEventListener('keydown', function (e) {
    if (KEYBOARD_KEYS[e.key]) lastInputType = 'keyboard';
  }, true);
  document.addEventListener('mousedown', function () { lastInputType = 'pointer'; }, true);
  document.addEventListener('pointerdown', function () { lastInputType = 'pointer'; }, true);
  document.addEventListener('touchstart', function () { lastInputType = 'pointer'; }, true);

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function findOverlay(selectorList) {
    for (var i = 0; i < selectorList.length; i++) {
      var nodes = document.querySelectorAll(selectorList[i]);
      for (var j = 0; j < nodes.length; j++) {
        var el = nodes[j];
        var rect = el.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) continue;
        var pos = window.getComputedStyle(el).position;
        if (pos === 'fixed' || pos === 'sticky') return el;
      }
    }
    return null;
  }

  var rafId = 0;

  function ensureVisible(target) {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(function () {
      rafId = 0;
      if (!target || !target.getBoundingClientRect || !document.contains(target)) return;

      var rect = target.getBoundingClientRect();
      if (rect.width === 0 && rect.height === 0) return;

      var viewportH = window.innerHeight || document.documentElement.clientHeight;
      var buffer = CONFIG.buffer;

      var header = findOverlay(CONFIG.headerSelectors);
      var footer = findOverlay(CONFIG.footerSelectors);

      var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var footerTop = footer ? footer.getBoundingClientRect().top : viewportH;

      var hiddenTop = rect.top - (headerBottom + buffer);
      var hiddenBottom = rect.bottom - (footerTop - buffer);

      var delta = 0;
      if (hiddenTop < 0) {
        // Covered by header → scroll page up.
        delta = hiddenTop;
      } else if (hiddenBottom > 0) {
        delta = Math.min(hiddenBottom, hiddenTop);
      } else {
        return; // Already fully visible.
      }

      if (Math.abs(delta) < 1) return;

      try {
        window.scrollBy({
          top: delta,
          left: 0,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      } catch (err) {
        window.scrollBy(0, delta);
      }
    });
  }

  function ensureCarouselItemVisible(carousel, item) {
    var viewport = carousel.querySelector('.flickity-viewport') || carousel;
    var itemRect = item.getBoundingClientRect();
    var viewportRect = viewport.getBoundingClientRect();
    var buffer = CONFIG.buffer;

    // Check if Flickity instance exists
    if (window.Flickity && carousel.classList.contains('flickity-enabled')) {
      var flickityInstance = Flickity.data(carousel);
      if (flickityInstance) {
        // Find the index of the focused cell
        var cells = flickityInstance.cells;
        var targetIndex = -1;
        
        for (var i = 0; i < cells.length; i++) {
          if (cells[i].element.contains(item)) {
            targetIndex = i;
            break;
          }
        }
        
        if (targetIndex !== -1) {
          flickityInstance.select(targetIndex, false, true);
          return;
        }
      }
    }

    // Fallback: use next/previous buttons if Flickity API not available
    if (itemRect.right > viewportRect.right + buffer || itemRect.left > viewportRect.right) {
      var nextButton = carousel.querySelector('.flickity-button.next, .flickity-prev-next-button.next');
      if (nextButton && !nextButton.disabled) {
        nextButton.click();
        setTimeout(function() {
          var newRect = item.getBoundingClientRect();
          if (newRect.left > viewportRect.right || newRect.right > viewportRect.right + buffer) {
            ensureCarouselItemVisible(carousel, item);
          }
        }, 350);
      }
    } else if (itemRect.left < viewportRect.left - buffer || itemRect.right < viewportRect.left) {
      var prevButton = carousel.querySelector('.flickity-button.previous, .flickity-prev-next-button.previous');
      if (prevButton && !prevButton.disabled) {
        prevButton.click();
        setTimeout(function() {
          var newRect = item.getBoundingClientRect();
          if (newRect.right < viewportRect.left || newRect.left < viewportRect.left - buffer) {
            ensureCarouselItemVisible(carousel, item);
          }
        }, 350);
      }
    }
  }

  function skipFeaturedProductsSliderFocus(root) {
    var sliders = [];

    if (root && root.matches && root.matches('.featured-products-slider')) {
      sliders.push(root);
    }

    if (root && root.querySelectorAll) {
      root.querySelectorAll('.featured-products-slider').forEach(function (slider) {
        sliders.push(slider);
      });
    }

    sliders.forEach(function (slider) {
      if (slider.getAttribute('tabindex') !== '-1') {
        slider.setAttribute('tabindex', '-1');
      }
    });
  }

  skipFeaturedProductsSliderFocus(document);

  if (window.MutationObserver) {
    var carouselFocusObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          skipFeaturedProductsSliderFocus(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) skipFeaturedProductsSliderFocus(node);
        });
      });
    });

    carouselFocusObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'tabindex'],
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('focusin', function (e) {
    if (lastInputType !== 'keyboard') return;
    var target = e.target;
    if (!target || target === document.body || target === document.documentElement) return;
    
    // Special handling for featured products carousel items
    var carouselItem = target.closest('.featured-product');
    if (carouselItem) {
      // Remove aria-hidden from focused item and ancestors
      var element = target;
      while (element && element !== document.body) {
        if (element.hasAttribute('aria-hidden')) {
          element.removeAttribute('aria-hidden');
        }
        element = element.parentElement;
      }
      
      // Find the carousel and move it to show focused item
      var carousel = target.closest('.featured-products-slider');
      if (carousel) {
        ensureCarouselItemVisible(carousel, carouselItem);
        
        // Also ensure the item is scrolled into view after carousel moves
        setTimeout(function() {
          ensureVisible(target);
        }, 300);
      }
      
      return;
    }
    
    ensureVisible(target);
  });

  window.themeFocusVisibility = {
    config: CONFIG,
    reveal: function (el) { ensureVisible(el || document.activeElement); }
  };
})();

// Quantity announcements for screen readers
(function () {
  'use strict';

  var liveRegion;

  function getLiveRegion() {
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.setAttribute('aria-live', 'assertive');
      liveRegion.setAttribute('aria-atomic', 'true');
      liveRegion.setAttribute('role', 'status');
      liveRegion.className = 'visually-hidden';
      document.body.appendChild(liveRegion);
    }
    return liveRegion;
  }

  // Speak an arbitrary string (used for hover announcements). The region is
  // cleared ~1s after speaking so stale text is not left in the DOM to be
  // re-read in browse mode. The timer is shared and reset on each call so a
  // rapid hover to another element cannot blank a fresh announcement early.
  // Re-hovering still re-announces: each call rewrites the text from empty.
  var announceTextTimer;
  function announceText(text) {
    if (!text) return;
    var region = getLiveRegion();
    region.textContent = '';
    region.textContent = text;
    clearTimeout(announceTextTimer);
    announceTextTimer = setTimeout(function() {
      region.textContent = '';
    }, 1000);
  }

  function announce(input) {
    if (!input) return;

    var qty = parseInt(input.value, 10) || 0;
    var region = getLiveRegion();
    region.textContent = '';
    setTimeout(function() {
      region.textContent = 'Quantity: ' + qty;
    }, 150);
  }

  function findInput(btn) {
    var parent = btn.closest('.qty-control, .quantity-input, .quantity-wrapper, .single-product-quantity-add-wrapper, .cart-quantity');
    return parent ? parent.querySelector('input[type="number"]') : null;
  }

  // Attach listeners to PDP quantity buttons (created dynamically)
  function attachPDPListeners() {
    document.querySelectorAll('.quantity-input .decrement-button, .quantity-input .increment-button').forEach(function(btn) {
      if (!btn.hasAttribute('data-a11y-listener')) {
        btn.setAttribute('data-a11y-listener', 'true');
        
        // Improve aria-label
        var input = findInput(btn);
        if (input) {
          var currentQty = parseInt(input.value, 10) || 1;
          if (btn.classList.contains('decrement-button')) {
            btn.setAttribute('aria-label', 'Decrease quantity, current quantity is ' + currentQty);
          } else {
            btn.setAttribute('aria-label', 'Increase quantity, current quantity is ' + currentQty);
          }
        }
        
        // Click handler
        btn.addEventListener('click', function() {
          var input = findInput(btn);
          if (input) {
            setTimeout(function() {
              // Update aria-label with new quantity
              var newQty = parseInt(input.value, 10) || 1;
              if (btn.classList.contains('decrement-button')) {
                btn.setAttribute('aria-label', 'Decrease quantity, current quantity is ' + newQty);
              } else {
                btn.setAttribute('aria-label', 'Increase quantity, current quantity is ' + newQty);
              }
              announce(input);
            }, 200);
          }
        });
        
        // Keyboard handler (Enter/Space)
        btn.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            btn.click();
          }
        });

        // Announce the button's purpose on mouse hover. The aria-label already
        // includes the current quantity, so reading it verbatim is enough.
        btn.addEventListener('mouseenter', function() {
          announceText(btn.getAttribute('aria-label'));
        });
      }
    });

    // Announce the current quantity when the mouse hovers over the number field.
    document.querySelectorAll('.product-quantity-input').forEach(function(input) {
      if (!input.hasAttribute('data-a11y-hover')) {
        input.setAttribute('data-a11y-hover', 'true');
        input.addEventListener('mouseenter', function() {
          var qty = parseInt(input.value, 10) || 0;
          announceText('Quantity: ' + qty);
        });
      }
    });
  }

  // Handle cart +/- button clicks
  document.addEventListener('click', function(e) {
    if (e.target.matches('.qty-plus, .qty-minus')) {
      var input = findInput(e.target);
      if (input) {
        setTimeout(function() { 
          announce(input);
        }, 150);
      }
    }
  }, true);

  // Handle keyboard activation for cart buttons
  document.addEventListener('keydown', function(e) {
    if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') && 
        e.target.matches('.qty-plus, .qty-minus')) {
      var input = findInput(e.target);
      if (input) {
        setTimeout(function() {
          announce(input);
        }, 150);
      }
    }
  });

  // Handle direct input changes (typing)
  var timer;
  document.addEventListener('input', function(e) {
    if (e.target.matches('input[name="quantity"], input[name="updates[]"], .product-quantity-input')) {
      clearTimeout(timer);
      timer = setTimeout(function() { 
        announce(e.target); 
      }, 500);
    }
  });

  // Also handle change event as backup
  document.addEventListener('change', function(e) {
    if (e.target.matches('input[name="quantity"], input[name="updates[]"], .product-quantity-input')) {
      clearTimeout(timer);
      announce(e.target);
    }
  });

  // Initialize PDP listeners after page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(attachPDPListeners, 500);
    });
  } else {
    setTimeout(attachPDPListeners, 500);
  }

  // Watch for dynamically added buttons
  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      var shouldCheck = false;
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.matches('.decrement-button, .increment-button') || node.querySelector('.decrement-button, .increment-button'))) {
            shouldCheck = true;
          }
        });
      });
      if (shouldCheck) {
        attachPDPListeners();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

// ============================================================
// Megamenu submenu items — announce on mouse hover
// A cold mouse hover opens the dropdown by toggling a class, but that does
// not fire a focus event, so the screen reader's buffer is never refreshed
// and mouse-tracking finds nothing to read. We bridge that by pushing each
// hovered item's accessible name into an aria-live region, which screen
// readers speak regardless of how it was triggered. Keyboard/touch flows are
// untouched — this only adds a mouseenter listener and never writes to the menu.
// ============================================================
(function () {
  'use strict';

  var MEGAMENU_SELECTOR = '.megamenu-dropdown-container';
  var ITEM_SELECTOR = '.megamenu-dropdown-container a';

  var announcer;

  function getAnnouncer() {
    if (announcer) return announcer;
    announcer = document.createElement('div');
    announcer.setAttribute('aria-live', 'assertive');
    announcer.setAttribute('aria-atomic', 'true');
    announcer.setAttribute('role', 'status');
    announcer.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;' +
      'padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';
    document.body.appendChild(announcer);
    return announcer;
  }

  function accessibleName(link) {
    var label = link.getAttribute('aria-label');
    if (label && label.trim()) return label.trim();
    var span = link.querySelector('span');
    if (span && span.textContent.trim()) return span.textContent.trim();
    return link.textContent.trim();
  }

  function announce(text) {
    if (!text) return;
    var region = getAnnouncer();
    region.textContent = '';
    region.textContent = text;
  }

  function bindItems() {
    document.querySelectorAll(ITEM_SELECTOR).forEach(function (link) {
      // Never announce the off-screen skip-menu link.
      if (link.classList.contains('skip-megamenu-link')) return;
      if (link.dataset.hoverAnnounceBound) return;
      link.dataset.hoverAnnounceBound = 'true';
      link.addEventListener('mouseenter', function () {
        announce(accessibleName(link));
      });
    });
  }

  function init() {
    if (!document.querySelector(MEGAMENU_SELECTOR)) return;
    bindItems();
    // Menus can be re-rendered; re-bind any newly added items.
    if (window.MutationObserver) {
      var observer = new MutationObserver(bindItems);
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ============================================================
// Rebuy Smart Cart (app-rendered) icon buttons
// The +/- and remove buttons are icon-only <button>s whose visible
// area is filled by an aria-hidden <i>. On mouse hover the pointer
// sits on the hidden icon, so screen-reader mouse tracking finds
// nothing to announce. Copy each button's accessible name onto its
// icon (as a named role="img") so the icon itself announces on hover.
// ============================================================
(function () {
  'use strict';

  var BTN_SELECTOR = '.rebuy-cart__flyout-item-quantity-widget-button, .rebuy-cart__flyout-item-remove';

  function nameRebuyIcons() {
    document.querySelectorAll(BTN_SELECTOR).forEach(function (btn) {
      var icon = btn.querySelector('i');
      if (!icon) return;

      var name = btn.getAttribute('aria-label');
      if (!name) {
        var srLabel = btn.querySelector('.sr-only');
        name = srLabel ? srLabel.textContent.trim() : btn.textContent.trim();
      }
      if (!name) return;

      // Guard prevents re-triggering the observer in a loop.
      if (icon.getAttribute('aria-label') !== name) {
        icon.setAttribute('role', 'img');
        icon.setAttribute('aria-label', name);
        icon.removeAttribute('aria-hidden');
      }
    });
  }

  function init() {
    nameRebuyIcons();
    if (window.MutationObserver) {
      var observer = new MutationObserver(nameRebuyIcons);
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ============================================================
// Footer social icons — announce on mouse hover
// Each social link's clickable area is filled by an inline <svg> that has no
// accessible name. Screen-reader mouse-tracking reads the innermost element
// under the pointer (the nameless svg) and announces nothing, even though the
// <a> itself has an aria-label. Push the link's accessible name into an
// aria-live region on hover so it is spoken regardless of what is under the
// pointer. Only adds a mouseenter listener; no markup or focus changes.
// ============================================================
(function () {
  'use strict';

  var LINK_SELECTOR = '.social-icons-footers a';

  var announcer;
  var clearTimer;

  function getAnnouncer() {
    if (announcer) return announcer;
    announcer = document.createElement('div');
    announcer.setAttribute('aria-live', 'assertive');
    announcer.setAttribute('aria-atomic', 'true');
    announcer.setAttribute('role', 'status');
    announcer.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;' +
      'padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';
    document.body.appendChild(announcer);
    return announcer;
  }

  function accessibleName(link) {
    var label = link.getAttribute('aria-label');
    if (label && label.trim()) return label.trim();
    var hidden = link.querySelector('.visuallyhidden');
    if (hidden && hidden.textContent.trim()) return hidden.textContent.trim();
    var title = link.getAttribute('title');
    return title ? title.trim() : link.textContent.trim();
  }

  function announce(text) {
    if (!text) return;
    var region = getAnnouncer();
    region.textContent = '';
    region.textContent = text;
    clearTimeout(clearTimer);
    clearTimer = setTimeout(function() {
      region.textContent = '';
    }, 1000);
  }

  function bindLinks() {
    document.querySelectorAll(LINK_SELECTOR).forEach(function (link) {
      if (link.dataset.hoverAnnounceBound) return;
      link.dataset.hoverAnnounceBound = 'true';
      link.addEventListener('mouseenter', function () {
        announce(accessibleName(link));
      });
    });
  }

  function init() {
    if (!document.querySelector(LINK_SELECTOR)) return;
    bindLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ============================================================
// Header controls & JudgeMe Stars — announce on mouse hover via Event Delegation
// ============================================================
(function () {
  'use strict';

  var SELECTOR = '.search-toggle, .header-cart-link, .search-terms, [data-hover-announce-bound="true"], .jdgm-rev-widg__summary-stars, .jdgm-preview-badge, .jdgm-prev-badge__stars, .jdgm-histogram__row, .jdgm-rev__stars, .jdgm-rev__rating, .jdgm-histogram__star';
  var announcer;
  var clearTimer;
  var activeElement = null;

  var announceTimer;
  var lastAnnouncedText = '';

  function getAnnouncer() {
    if (announcer) return announcer;
    announcer = document.createElement('div');
    announcer.setAttribute('aria-live', 'assertive');
    announcer.setAttribute('aria-atomic', 'true');
    announcer.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;' +
      'padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';
    document.body.appendChild(announcer);
    return announcer;
  }

  function announce(text) {
    if (!text || text === lastAnnouncedText) return;
    lastAnnouncedText = text;
    
    var region = getAnnouncer();
    region.textContent = '';
    
    clearTimeout(announceTimer);
    announceTimer = setTimeout(function() {
      region.textContent = text;
    }, 50);

    clearTimeout(clearTimer);
    clearTimer = setTimeout(function() {
      region.textContent = '';
      lastAnnouncedText = '';
    }, 2000);
  }

  function init() {
    document.body.addEventListener('mouseover', function (event) {
      var el = event.target.closest(SELECTOR);
      if (!el) return;
      if (el === activeElement) return;
      activeElement = el;

      var label = el.getAttribute('aria-label') || el.getAttribute('title');
      if (!label && el.classList.contains('jdgm-histogram__row')) {
        var starEl = el.querySelector('.jdgm-histogram__star');
        label = starEl ? starEl.getAttribute('aria-label') : '';
      }
      if (!label) {
        var vhEl = el.querySelector('.visually-hidden');
        if (vhEl) {
          label = vhEl.textContent.trim();
        } else {
          label = el.textContent.trim();
        }
      }
      
      // Custom logic for cart link to include item count
      if (el.classList.contains('header-cart-link')) {
        var countEl = el.querySelector('.cart-count');
        var count = countEl ? countEl.textContent.trim() : '0';
        label = (label || 'Cart') + ', ' + count + (count === '1' ? ' item' : ' items');
      }
      
      announce(label);
    });

    document.body.addEventListener('mouseout', function (event) {
      var el = event.target.closest(SELECTOR);
      if (el && el === activeElement) {
        activeElement = null;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
